import { useEffect, useState } from "react";
import { collection, limit, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../../../../config/firebaseConfig";

export function useAllDedouanements(terminal, produit, lots) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!terminal || !produit || lots.length === 0) {
      setRows([]);
      return;
    }

    const lotsCollection = produit === "essence" ? "lots_su" : "lots_go";
    const perLot = {};
    const unsubs = [];

    const merge = () => {
      const all = Object.values(perLot)
        .flat()
        .sort((a, b) => {
          const tA = a.createdAt?.seconds ?? a.date?.seconds ?? 0;
          const tB = b.createdAt?.seconds ?? b.date?.seconds ?? 0;
          return tB - tA;
        });
      setRows(all);
    };

    for (const lot of lots) {
      perLot[lot.id] = [];
      const ref = query(
        collection(db, "terminaux", terminal, lotsCollection, lot.id, "dedouanements"),
        orderBy("createdAt", "desc"),
        limit(50),
      );
      const unsub = onSnapshot(
        ref,
        (snap) => {
          perLot[lot.id] = snap.docs.map((d) => ({
            id: d.id,
            lotId: lot.id,
            lotRef: lot.numeroPOT || lot.bl || lot.pot || lot.id,
            ...d.data(),
          }));
          merge();
        },
        () => {},
      );
      unsubs.push(unsub);
    }

    return () => unsubs.forEach((u) => u());
  }, [terminal, produit, lots]);

  return rows;
}
